<template>
  <div class="input-group input-group-sm">
    <select v-model="filter.operator" class="form-control form-control-sm">
      <option v-for="operator in operators" :value="operator.value">
        {{ operator.label }}
      </option>
    </select>
    <template v-if="filter.operator !== 'isNull'">
      <input v-model="filter.value" type="date" class="form-control form-control-sm" @keyup.enter="$emit('submit')">
      <span
        v-if="filter.operator === 'between'"
        class="input-group-append"
      >
        <span class="input-group-text">and</span>
      </span>
      <input
        v-if="filter.operator === 'between'"
        v-model="filter.valueTwo"
        type="date"
        class="form-control form-control-sm"
        @keyup.enter="$emit('submit')"
      >
    </template>
  </div>
</template>
<script>
  import { operators } from './date';

  export default {
    props: {
      filter: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        operators
      };
    },
    beforeMount() {
      if (!this.filter.operator) {
        this.filter.operator = 'between';
      }
      if (!this.filter.value) {
        this.filter.value = '';
      }
      if (!this.filter.valueTwo) {
        this.$set(this.filter, 'valueTwo', '');
      }
    },
  };
</script>

<style scoped>
  input[type=date] {
    min-width: 120px;
  }
</style>
